import React from 'react'

function Blog() {
  return (
    <div class="page_wrapper"></div>
  )
}

export default Blog